import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import './styles.scss'
const baseClass = 'plus-minus-buttons'

const PlusMinusButtons = ({ onAdd, onRemove, className, addingDisabled, deletingDisabled }) => (
  <div className={cn(`${baseClass}__count-controls`, className)}>
    <button
      type="button"
      className={cn(`${baseClass}__count-control`, `${baseClass}__count-control--delete`)}
      onClick={onRemove}
      disabled={deletingDisabled}
    />
    <button
      type="button"
      className={cn(`${baseClass}__count-control`, `${baseClass}__count-control--add`)}
      onClick={onAdd}
      disabled={addingDisabled}
    />
  </div>
)

PlusMinusButtons.propTypes = {
  className: PropTypes.string,
  onAdd: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
}

export default PlusMinusButtons
